import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import type { ElForm } from 'element-ui/types/form';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

export const iconType = {
  HOT: 'QIKAN',
  SHOP: 'SITE',
  CLASS: 'CLASSIFY',
  ACTIVE: 'ACT',
  MY: 'MINE',
  CART: 'CART',
  CUSTOM: 'CUSTOM',
  SALE: 'SALE',
};

export const iconList = {
  [iconType.HOT]: [
    { icon: 'iconHOT', choseIcon: 'iconHOTxuanzhong' },
    { icon: 'iconremen1', choseIcon: 'iconremen' },
  ],
  [iconType.SHOP]: [
    { icon: 'iconshangcheng', choseIcon: 'iconshangchengxuanzhong' },
    { icon: 'iconshangcheng1', choseIcon: 'iconshangcheng-1' },
  ],
  [iconType.CLASS]: [
    { icon: 'iconfenlei', choseIcon: 'iconfenleixuanzhong' },
    { icon: 'iconfenlei1', choseIcon: 'iconfenlei-1' },
  ],
  [iconType.ACTIVE]: [
    { icon: 'iconhuodong', choseIcon: 'iconhuodongxuanzhong' },
    { icon: 'iconhuodong1', choseIcon: 'iconhuodong21' },
  ],
  [iconType.MY]: [
    { icon: 'iconwo', choseIcon: 'iconwoxuanzhong' },
    { icon: 'iconwode', choseIcon: 'iconwode1' },
  ],
  [iconType.CART]: [
    { icon: 'icongouwuche1', choseIcon: 'icongouwuchexuanzhong' },
    { icon: 'iconcaigou-xianxing', choseIcon: 'iconcaigou' },
  ],
  [iconType.CUSTOM]: [
    { icon: 'iconqita', choseIcon: 'iconqita1' },
    { icon: 'iconfenleiorguangchangorqita', choseIcon: 'iconfenleiorguangchangorqitatianchong' },
  ],
  [iconType.SALE]: [
    { icon: 'iconhuodong', choseIcon: 'iconhuodongxuanzhong' },
    { icon: 'iconhuodong1', choseIcon: 'iconhuodong21' },
  ],
};

@DialogFactory
@Component({
  mixins: [style],
  components: {
    Upload,
  },
})
export default class SelectIocnDialog extends IPSDialog {
  // 会被传入参数覆盖的值
  type = '';

  title = '导航图标';

  width = '700px';

  choseIcon: any = {};

  iconList = [];

  iconValue: { icon?: string; choseIcon?: string } = { icon: '', choseIcon: '' };

  isCustom = 0;

  $refs: {
    iconForm: ElForm;
  };

  mode = 1;

  rules = {
    icon: [{ required: true, validator: this.validatePic, trigger: ['change', 'blur'] }],
  };

  onCheckIcon(icon) {
    this.choseIcon = icon;
  }

  mounted() {
    this.iconList = iconList[this.type] || [];
    if (this.isCustom) {
      this.iconValue = this.choseIcon;
    }
    if (this.mode === 2) {
      this.rules['choseIcon'] = [{ required: true, validator: this.validatePic, trigger: ['change', 'blur'] }];
    }
  }

  validatePic(rule, value, callback) {
    if (!value) {
      return callback(new Error('请上传图片'));
    } else {
      callback();
    }
  }

  getResults() {
    if (this.isCustom) {
      return { result: this.iconValue, type: 1 };
    } else {
      return { result: this.choseIcon, type: 0 };
    }
  }

  beforeConfirm() {
    if (this.isCustom) {
      this.$refs.iconForm.validate((valid) => {
        if (valid) {
          this.$emit('result', this.getResults());
          this.confirmloading = false;
          this.$emit('hidden');
        } else {
          this.confirmloading = false;
        }
      });
    } else {
      // this.getResults();
      this.$emit('result', this.getResults());
      this.$emit('hidden');
    }
  }

  changeRadio(val) {
    this.isCustom = val;
    if (!val) {
      this.choseIcon = iconList[this.type][0];
    }
  }

  uploadSuccess(val, flag) {
    if (flag) {
      this.iconValue.choseIcon = val.content;
    } else {
      this.iconValue.icon = val.content;
    }
  }

  onRemoveIcon(url) {
    this.iconValue.icon = url;
  }

  onRemoveChoseIcon(url) {
    this.iconValue.choseIcon = url;
  }

  renderContent(h: CreateElement): VNode {
    return (
      <div class="r-px-40">
        {this.mode === 2 ? (
          <div>
            <div class="line-height-48">
              <el-radio-group v-model={this.isCustom} onChange={this.changeRadio.bind(this)}>
                <el-radio label={0}>使用默认图标</el-radio>
                <el-radio label={1}>自行上传图标</el-radio>
              </el-radio-group>
            </div>

            {this.isCustom === 0 ? (
              <div class="selectIconWrapper">
                <ul class="ul-class1">
                  {this.iconList.map((icon, index) => {
                    return (
                      <li key={index} onClick={this.onCheckIcon.bind(this, icon)} class={{ 'check-li': icon.icon == this.choseIcon.icon, 'li-class': true }}>
                        {icon.icon === this.choseIcon.icon ? <i class="el-icon-circle-check-outline circle-check" /> : ''}
                        <i class={['fl', `iconfont ${icon.icon}`]} />
                        <i class={['fr', `iconfont ${icon.choseIcon}`]} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              ''
            )}
            {!!this.isCustom && (
              <div class="custom-icon">
                <el-form props={{ model: this.iconValue }} ref="iconForm" rules={this.rules} label-position="top">
                  <el-form-item prop="icon" class="r-mb-0" label="未选中图标">
                    <el-checkbox-group v-model={this.iconValue.icon}></el-checkbox-group>
                    <Upload img={this.iconValue.icon} onImgUploadSuccess={val => this.uploadSuccess(val, 0)} maxSize={1024} onDelete={url => this.onRemoveIcon(url)} typeIcon={true} />
                  </el-form-item>
                  <el-form-item prop="choseIcon" class="r-mb-0" label="已选中图标">
                    <el-checkbox-group v-model={this.iconValue.choseIcon}></el-checkbox-group>
                    <Upload onImgUploadSuccess={val => this.uploadSuccess(val, 1)} img={this.iconValue.choseIcon} maxSize={1024} onDelete={url => this.onRemoveChoseIcon(url)} typeIcon={true} />
                  </el-form-item>
                  <span class="tip">
                    <span class="text-red r-mr-8">*</span>请上传分辨率为100*100px的图片，仅支持SVG及PNG格式。
                  </span>
                </el-form>
              </div>
            )}
          </div>
        ) : (
          <div class="selectIconWrapper">
            <div>
              <ul class="ul-class">
                {this.iconList.map((icon, index) => {
                  return (
                    <li key={index} onClick={this.onCheckIcon.bind(this, icon)} class={{ 'check-li': icon.icon == this.choseIcon.icon, 'li-class': true }}>
                      {icon.icon === this.choseIcon.icon ? <i class="el-icon-circle-check-outline circle-check" /> : ''}
                      <i class={`iconfont ${icon.icon}`} />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }
}
